import { graphql } from '../../graphql/generated';

export const DIRECT_FORMS_QUERY = graphql(`
  query DirectForms($doctorId: ID!) {
    directForms(doctorId: $doctorId) {
      ...FormRenderer_Form
    }
  }
`);
